<template>
    <a
        :href="'/campaigns/' + job.jobable_id + '/jobs/' + job.id"
        class="list-group-item flex v-center"
        :class="'--' + job.status"
    >
        <div class="w-full" style="padding: 0 30px;color: #1825d8;">

            <img
                :src="job.influencer.profile_photo_url"
                alt=""
                class="mx-auto md:mx-0"
                style="width: 200px;height: 200px;border-radius: 100%;margin-top: -75px;"
            />

            <h5 class="strong inline-block m-r-sm mt-5 uppercase" style="color: #1825d8;">{{ job.influencer.name }}</h5>

            <rating-stars
                v-model="job.influencer.reviews_score"
                class="m-b-sm"
                :disabled="true"
            ></rating-stars>
            <!--
            <div class="m-l-xs m-r-xs">{{ job.influencer.reviews_score }}</div>
            <div>({{ job.influencer.reviews_count }})</div>

            <job-status :status="job.status" class="text-sm"></job-status>
            -->

            <div class="w-full flex justify-between mt-5">
                <div class="">
                    <h5 style="font-size: 14px;color: #1825d8;font-weight: 600;margin-bottom: 3px;">{{ platform.reach_name }}</h5>
                    <span class="" style="font-size: 14px;color: #1825d8;font-weight: 600;">{{ job.reach_estimated }}</span>
                </div>
                <div class="text-right">
                    <h5 style="font-size: 14px;color: #1825d8;font-weight: 600;margin-bottom: 3px;">Pris</h5>
                    <amount class="" style="font-size: 14px;color: #1825d8;font-weight: 600;" :value="job.influencer_cost"></amount>
                </div>
            </div>

            <div class="flex justify-between mt-5 mb-5">
                <h5 class="flex-grow text-right" style="line-height: 25px;font-size: 14px;color: #FC0403;font-weight: normal;">Opslag</h5>
                <p style="margin-left: 30px;border: 1px solid #1825d8;color: #1825d8;font-size: 14px;height: 25px;line-height: 25px;width: 25px;text-align: center;">{{ job.posts }}</p>
            </div>

            <div class="text-center mb-5 mt-7">
                <span style="background: #FC0403; padding: 5px 20px; color: white; margin-top: 10px;font-weight: 600;">Se detaljer</span>
            </div>

        </div>
    </a>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';
@import '~dashboard-less/spark/utilities';

.CampaignJobCard {
    border-left-style: solid;
    border-left-width: 5px !important;
    border-left-color: @color-gray-light;

    &.--applied {
        border-left-color: @brand-primary;
    }

    &.--finished {
        border-left-color: @brand-success;
    }
}

.CampaignJobCard__rating {
    display: inline-flex;
    min-width: 150px;

    .star {
        font-size: 20px;
    }
}

.list-group .CampaignJobCard:first-child {
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
}
.list-group .CampaignJobCard:last-child {
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
}
</style>

<script type="text/babel">
export default {
    props: ['job', 'platform'],
}
</script>
